import { render, staticRenderFns } from "./Revotax.vue?vue&type=template&id=08f78a36&"
import script from "./Revotax.vue?vue&type=script&lang=js&"
export * from "./Revotax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports